import Fuse from 'fuse.js'
import { orderBy } from 'lodash'
import { OptionsType } from 'services/types'
import { insertIf, removeDiacritics } from 'common'
import { FILTER_MAX_RESULT_VISIBLE, FILTER_MIN_INPUT_LENGTH } from 'constant'

type Props = {
  userInput: string
  type: string
  sortedOptions: OptionsType[]
  initialOptions?: OptionsType[]
}

const getFilteredOptions = ({ userInput, type, sortedOptions }: Props): OptionsType[] => {
  const fuseKeys = getFuseKeys(type, userInput)

  const fuseOptions = {
    threshold: 0.1,
    ignoreLocation: true,
    getFn: (obj: OptionsType, path: string | string[]): string | readonly string[] => {
      const value = Fuse.config.getFn(obj, path)
      if (typeof value === 'string') return removeDiacritics(value)
      return value
    },
    keys: fuseKeys
  }
  const fuse = new Fuse(sortedOptions, fuseOptions)
  const filteredOptions = fuse
    .search(removeDiacritics(userInput))
    .slice(0, userInput.length < FILTER_MIN_INPUT_LENGTH ? FILTER_MAX_RESULT_VISIBLE : undefined)
    .map(result => result.item)

  return orderBy(filteredOptions, ['archived'], ['desc'])
}

const getFuseKeys = (type: string, userInput: string) => {
  const isUsersFilter = type === 'users'
  const isSearchingUserByEmail = isUsersFilter && userInput.includes('@')
  const isProjectFilter = type === 'projects'
  const keys = [
    'label',
    ...insertIf(isUsersFilter, 'alt.employeeNumber'),
    ...insertIf(isSearchingUserByEmail, 'alt.email'),
    ...insertIf(isProjectFilter, 'alt')
  ]
  return keys
}

export default getFilteredOptions
